"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoints = void 0;
exports.default = useWindowDimensions;
exports.useContainerDimensions = void 0;
exports.useResponsiveChecks = useResponsiveChecks;
var _react = require("react");
// javascript/style-guide/config.js
var breakpoints = exports.breakpoints = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1360
};
function getWindowDimensions() {
  var _window = window,
    width = _window.innerWidth,
    height = _window.innerHeight;
  return {
    width: width,
    height: height
  };
}
var useResizeListener = function useResizeListener(onResize) {
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
};
function useWindowDimensions() {
  var _ref = (0, _react.useState)(getWindowDimensions()),
    _ref2 = _slicedToArray(_ref, 2),
    windowDimensions = _ref2[0],
    setWindowDimensions = _ref2[1];
  useResizeListener(function () {
    return setWindowDimensions(getWindowDimensions());
  });
  return windowDimensions;
}
function useResponsiveChecks() {
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var isMobile = (0, _react.useMemo)(function () {
    return width < breakpoints.sm;
  }, [width]);
  var isTabletVert = (0, _react.useMemo)(function () {
    return width >= breakpoints.sm && width < breakpoints.md;
  }, [width]);
  var isTabletHoriz = (0, _react.useMemo)(function () {
    return width >= breakpoints.md && width < breakpoints.lg;
  }, [width]);
  var isLaptopSmall = (0, _react.useMemo)(function () {
    return width >= breakpoints.lg && width < breakpoints.xl;
  }, [width]);
  return {
    isMobile: isMobile,
    isTabletVert: isTabletVert,
    isTabletHoriz: isTabletHoriz,
    isLaptopSmall: isLaptopSmall
  };
}
var useContainerDimensions = function useContainerDimensions(myRef) {
  var _ref3 = (0, _react.useState)({
      width: 0,
      height: 0
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    dimensions = _ref4[0],
    setDimensions = _ref4[1];
  var updateDimensions = function updateDimensions() {
    return {
      width: myRef.current.offsetWidth,
      height: myRef.current.offsetHeight
    };
  };
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      setDimensions(updateDimensions());
    };
    if (myRef.current) {
      setDimensions(updateDimensions());
    }
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [myRef]);
  return dimensions;
};
exports.useContainerDimensions = useContainerDimensions;